import * as React from 'react';
import { AppBar, Box, Button, Drawer, IconButton, Toolbar, Typography, useTheme } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import resume from '../../../files/resume.pdf'
import { makeStyles } from '@mui/styles';
import List from '@mui/material/List';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';


function Header() {

  const index = useParams().index;
  const location = useLocation().pathname;
  console.log(location)

  const theme = useTheme();
  const useStyle = makeStyles({
    navIcon: {
      [theme.breakpoints.up('md')]: {
        display:'none !important'
      }
    },
    navItemContainer: {
      [theme.breakpoints.down('md')]: {
        display:'none !important'
      }
    },
    navLogo: {
      [theme.breakpoints.down('md')]: {
        textAlign: 'center'
      }
    },
    paper: {
      background: "#263238 !important"
    }
  })
  const { navIcon, navItemContainer, navLogo, paper } = useStyle();
  
  const [state, setState] = React.useState(false);


  const list = () => (
    <Box
      sx={{ width: 250 }}
      role="presentation"
    >
      { location === "/" &&
        <List>
          <Button color="inherit"><a style={{ textDecoration: 'none', color: 'white' }} href="#myProjects">My Projects</a></Button>
          <br />
          <Button color="inherit"><a style={{ textDecoration: 'none', color: 'white' }} href="#aboutMe">About Me</a></Button>
          <br />
          <Button color="inherit"><a style={{ textDecoration: 'none', color: 'white' }} href="#contact">Get In Touch</a></Button>
          <br />
          <Button color="inherit"><Link style={{ textDecoration: 'none', color: 'white' }} to="/blogs">Blogs</Link></Button>
          <br />
          <Button color="inherit"><a style={{ textDecoration: 'none', color: 'white' }} href={resume} download>Download Resume</a></Button>
        </List>
      }
    </Box>
  );

  return (
    <>
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="fixed" style={{backgroundColor: '#def7e5', color: 'black'}}>
          <Toolbar>
          {
              location === "/" &&
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ mr: 2 }}
                  className={navIcon}
                  onClick={()=>setState(true)}
              >
                <MenuIcon />
              </IconButton>
          }
          <Typography className={navLogo} variant="h6" component="div" sx={{ flexGrow: 1 }}>
            <Link style={{textDecoration: 'none', color: 'black'}} to="/">Mahadi Hassan Riyadh</Link>
          </Typography>
          {
              location === "/" &&
              <Box className={navItemContainer}>
                <Button color="inherit"><a style={{textDecoration: 'none', color: 'black'}} href="#myProjects">My Projects</a></Button>
                <Button color="inherit"><a style={{textDecoration: 'none', color: 'black'}} href="#aboutMe">About Me</a></Button>
                <Button color="inherit"><a style={{ textDecoration: 'none', color: 'black' }} href="#contact">Get In Touch</a></Button>
                <Button color="inherit"><Link style={{ textDecoration: 'none', color: 'black' }} to="/blogs">Blogs</Link></Button>
                <Button color="inherit"><a style={{textDecoration: 'none', color: 'black'}} href={resume} download>Download Resume</a></Button>
              </Box>
          }
        </Toolbar>
      </AppBar>
    </Box>
       <div>
         <React.Fragment>
          <Drawer
            classes={{ paper: paper }}
             open={state}
             onClose={()=>setState(false)}
           >
             {list()}
           </Drawer>
         </React.Fragment>
     </div>
    </>
  );
}


export default Header;
